import { KeyValueModel } from "model";
import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";

export const TpStatusTransferenciaMock: KeyValueModel[] = [
    new KeyValueModel(EnumStatusTransferencia.SemRemessa, "Sem Remessa"),
    new KeyValueModel(EnumStatusTransferencia.Pendente, "Pendente"),
    new KeyValueModel(EnumStatusTransferencia.Aceito, "Aceito"),
    new KeyValueModel(EnumStatusTransferencia.Autorizada, "Autorizada"),
    new KeyValueModel(EnumStatusTransferencia.Rejeitada, "Rejeitada"),
    new KeyValueModel(EnumStatusTransferencia.Expirada, "Expirada"),
    new KeyValueModel(EnumStatusTransferencia.ProcessandoEstorno, "Processando Estorno"),
    new KeyValueModel(EnumStatusTransferencia.Estornada, "Estornada"),
    new KeyValueModel(EnumStatusTransferencia.Abortada, "Abortada"),
    new KeyValueModel(EnumStatusTransferencia.ErroInterno, "Erro Interno"),
    new KeyValueModel(EnumStatusTransferencia.Todos, "Todos"),
];
